<template>
    <Modal v-model="show"
        :width="90"
        :footer-hide="true"
        title="备用库入库单编辑"
        class-name="vertical-center-modal"
        @on-visible-change="onShowChange">
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="12">
                <Card class="thin-card-title">
                    <p slot="title">已审核产品</p>
                    <search-card :form="productTable.searchForm"
                        :table-load-event="getProductTableRecords"
                        :table-search="productTable.tableSearch"
                        :col-span="8"
                        :search-btn-col-span="8" />

                    <Row :gutter="16">
                        <Col span="24">
                        <stand-pagination-table :columns="productTable.tableColumns"
                            :data="productTable.tableData"
                            :loading="productTable.tableLoading"
                            :autoHeight="true"
                            :table-search="productTable.tableSearch"
                            :table-load-event="getProductTableRecords"
                            @on-selection-change="onProductSelect" />
                        </Col>
                    </Row>

                    <Divider />
                    <Row :gutter="16">
                        <Col span="24">
                        <Button :disabled="productTable.selection.length === 0"
                            type="primary"
                            long
                            @click="onEntryProducts">添加所选</Button>
                        </Col>
                    </Row>
                </Card>
                </Col>

                <Col span="12">
                <Card class="thin-card-title">
                    <p slot="title">入库产品</p>
                    <Button slot="extra"
                        size="small"
                        :disabled="entryTable.tableData.length === 0"
                        type="primary"
                        :loading="entryTable.loading"
                        @click="onSubmit">提交入库</Button>
                    <Table :columns="entryTable.tableColumns"
                        size="small"
                        :loading="entryTable.loading"
                        :data="entryTable.tableData"
                        :border="true"
                        :stripe="true" />
                </Card>
                </Col>
            </Row>
        </Card>
    </Modal>

</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { singleImageRender } from '@/libs/tableRowImageRender';
import { APPROVAL_YES } from '@/libs/baseModelFormat';
import { number2ThousandsFormat } from '@/components/number-input/display-format';
import DecimalInput from '@/components/number-input/decimal-input';
import IntegerInput from '@/components/number-input/integer-input';
import {
    DEPARTMENT_TYPE_BINFEN,
    DEPARTMENT_TYPE_EXTERNAL
} from '@/view/system-management/department-management/DepartmentTypeDefine';

import { getProductList } from '@/api/modules/product-management/product-management';
import { saveWarehouseForwardEntry } from '@/api/modules/warehouse-management/warehouseEntry';
import { getDepartmentList } from '@/api/modules/system-management/department-management';

export default {
    name: 'WarehouseForwardEntryEdit',
    components: {
        SearchCard,
        StandPaginationTable,
        DecimalInput,
        IntegerInput
    },
    data() {
        return {
            show: false,
            DEPARTMENT_TYPE_EXTERNAL,
            DEPARTMENT_TYPE_BINFEN,
            departmentType: DEPARTMENT_TYPE_BINFEN,
            warehouseForwardEntryFrom: {
                warehouseForwardEntryRecordUuid: '',
                warehouseForwardEntryRecordProject: '',
                warehouseForwardEntryRecordContactNumber: '',
                warehouseForwardEntryRecordBillCode: '',
                warehouseForwardEntryRecordStatus: '',
                warehouseForwardEntryRecordCreateAt: '',
                userPersonName: ''
            },
            ruleValidate: {
                warehouseForwardEntryRecordProject: [{ required: true, message: ' ', trigger: 'blur' }]
            },
            productTable: {
                tableColumns: [
                    { title: '', type: 'selection', width: 80, align: 'center' },
                    { title: '产品编号', key: 'productCode', align: 'center' },
                    { title: '名称', key: 'productName', align: 'center' },
                    { title: '单位', key: 'unitName', align: 'center' },
                    {
                        title: '预售价',
                        key: 'productPreSalePrice',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, number2ThousandsFormat(params.row.productPreSalePrice, 4, '￥'))
                            ]);
                        }
                    },
                    { title: '成品图', align: 'center', render: (h, params) => singleImageRender(h, params.row.productFinishImageFile) }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '名称', type: 'Input', value: '', name: 'productName', sql: 'like' },
                    { label: '产品编号', type: 'Input', value: '', name: 'productCode', sql: 'like' }
                ],
                selection: []
            },
            entryTable: {
                loading:false,
                tableColumns: [
                    { title: '产品编号', key: 'productCode', align: 'center' },
                    { title: '名称', key: 'productName', align: 'center' },
                    {
                        title: '预售价',
                        key: 'productPreSalePrice',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, number2ThousandsFormat(params.row.productPreSalePrice, 4, '￥'))
                            ]);
                        }
                    },
                    {
                        title: '入库数量',
                        key: 'warehouseForwardEntryDetailAmount',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h(DecimalInput, {
                                props: {
                                    value: params.row.warehouseForwardEntryDetailAmount,
                                    max: 1000000,
                                    precision: 0
                                },
                                on: {
                                    change: newVal => {
                                        this.entryTable.tableData[params.index].warehouseForwardEntryDetailAmount = newVal;
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    on: {
                                        click: () => {
                                            this.onRemoveEntryProduct(params.index);
                                        }
                                    }
                                }, '删除')
                            ]);
                        }
                    }
                ],
                tableData: []
            },
            departmentSource: [],
            deaprtmentOptions: []
        };
    },
    mounted() {
        // this.getProductTableRecords();
        // this.getDepartmentSource();
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal() {
            this.show = true;
        },
        init() {
            this.getProductTableRecords();
            this.getDepartmentSource();
        },
        getDepartmentSource() {
            const searchCondition = search.getSearchParams({ closeAllConditions: true });
            getDepartmentList(searchCondition).then(res => {
                if (res.code === 0) {
                    this.departmentSource = res.data.records;
                    this.onDepartmentChange();
                }
            });
        },
        getProductTableRecords(reset = false) {
            this.productTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.productTable.tableSearch);
            }

            // 强制设置已审核的过滤
            this.productTable.tableSearch.filters.enable = true;
            const approveFilterQuery = this.productTable.tableSearch.filters.conditions.find(f => f.name === 'productApproval');
            if (approveFilterQuery) {
                approveFilterQuery.value = APPROVAL_YES;
                approveFilterQuery.type = 'eq';
            }
            else {
                this.productTable.tableSearch.filters.conditions.push({
                    name: 'productApproval',
                    type: 'eq',
                    value: APPROVAL_YES
                });
            }

            getProductList(this.productTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.productTable.tableData = res.data.records;
                    search.globalSetFilterRecordCount(this.productTable.tableSearch, res.data.filterRecordCount);
                }

                this.productTable.tableLoading = false;
            });
        },
        onProductSelect(selection) {
            this.productTable.selection = selection;
        },
        onEntryProducts() {
            if (this.productTable.selection.length === 0) {
                return;
            }

            const products = this.productTable.selection.filter(p => {
                return !this.entryTable.tableData.find(s => s.productUuid === p.productUuid);
            }).map(p => {
                return Object.assign(p, {
                    warehouseForwardEntryDetailAmount: 0,
                    warehouseForwardEntryDetailRemark: ''
                });
            });

            this.entryTable.tableData.push(...products);
        },
        onRemoveEntryProduct(index) {
            this.entryTable.tableData.splice(index, 1);
        },
        onSubmit() {
            if (this.entryTable.tableData.length === 0) {
                this.$Message.error('请至少添加一个入库产品!');
                return;
            }

            const checkEmpty = this.entryTable.tableData.find(p => p.warehouseForwardEntryDetailAmount === 0);
            if (checkEmpty) {
                this.$Message.error('所有产品必须设定 入库数量');
                return;
            }

            const submitData = Object.assign({}, this.warehouseForwardEntryFrom);
            submitData.entryProducts = this.entryTable.tableData.map(p => {
                return {
                    warehouseForwardEntryDetailRelateProductUuid: p.productUuid,
                    warehouseForwardEntryDetailAmount: p.warehouseForwardEntryDetailAmount,
                    warehouseForwardEntryDetailPrice: p.productPreSalePrice,
                    warehouseForwardEntryDetailRemark: ''
                };
            });

            this.entryTable.loading = true;
            saveWarehouseForwardEntry(submitData).then(res => {
                this.entryTable.loading = false;
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.show = false;
                            this.$parent.init();
                        }
                    });
                }
            }).catch(() => {
                this.entryTable.loading = false;
            });
        },
        onDepartmentChange() {
            this.deaprtmentOptions = this.departmentSource.filter(d => d.departmentType === this.departmentType);
        }
    }
};
</script>

<style scoped>
</style>
